import { ArrowLeft } from '@/components/icons'
import { gameNumbers } from '@/constants/Common'
import { Team } from '@/types'

type Props = {
  className?: string
  team: Team
  opponentTeam: Team
}

export const ScoreTeam = ({ className, team, opponentTeam }: Props) => {
  return (
    <div className={`flex justify-end gap-x-1 ${className}`}>
      <div className="flex xs:gap-x-0.5 items-center justify-end">
        {gameNumbers.map(
          (gameNumber) =>
            team &&
            team[gameNumber] !== -1 && (
              <div key={gameNumber} className="flex justify-center items-center">
                <span
                  className={`text-navy-900 align-middle text-center ${
                    opponentTeam ? (team[gameNumber] > opponentTeam[gameNumber] ? '' : 'opacity-50') : ''
                  } w-[20px] h-[22px] text-sm font-medium`}
                >
                  {team[gameNumber].toString()}
                </span>
              </div>
            )
        )}
      </div>
      <div className={`flex justify-center items-center ${team?.winner ? 'opacity-100' : 'opacity-0'}`}>
        <ArrowLeft className="md:w-1.5 md:h-3" />
      </div>
    </div>
  )
}
